
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const CreditCard = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="CreditCard" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M0 2v12h16V2zm15 11H1V7h14zm0-7H1V5h14zm0-2H1V3h14zM3.98248 11.99969a1.98016 1.98016 0 001-.278 2 2 0 100-3.444 2 2 0 10-1 3.722zm1.749-2.951a.93073.93073 0 01.251-.049 1 1 0 110 2 .974.974 0 01-.251-.051 1.922 1.922 0 00-.00001-1.90001zm-1.749-.049a.97356.97356 0 01.251.051 1.922 1.922 0 000 1.9.93114.93114 0 01-.251.049 1 1 0 010-2z" />
</svg>
    </HvIconBase>
)};

CreditCard.propTypes = HvIconBase.propTypes;

export default CreditCard;